<template>
    <form-select
        placeholder="月"
        selectName="month"
        :optionList="setOptions()"
        v-model="month"
        :value="monthValue"
        :blur-event="onBlur"
        data-jest="select-month"
    />
</template>

<script>
import FormSelect from "../atoms/FormSelect.vue";
import moment from "moment";
export default {
    name: "InputProfileItemMonth",
    components: {FormSelect},
    props: {
        /**
         * storeのyear
         */
        yearValue: {
            type: String,
            required: true
        },
        /**
         * storeのmonth
         */
        monthValue: {
            type: String,
            required: true
        },
        /**
         * 入力値が空か
         * blur時のバリデーション判定用
         */
        isEmpty: {
            type: Boolean,
            required: true
        },
    },
    emits: ['input'],
    computed: {
        month: {
            get() {
                return this.monthValue
            },
            set(value) {
                return this.emit(value);
            }
        },
        isEmptyMonth: {
            get() {
                return this.isEmpty
            },
            set() {
                return this.emit(this.month);
            }
        },
    },
    methods: {
        /**
         * 引数の範囲でoptionを生成する
         */
        setOptions() {
            const start = 1;
            let last = 12;
            const now = moment();
            if(this.yearValue === now.year().toString()) {
                last = now.month() + 1;
            }
            let list = [];
            for(let i = start; i <= last; i++) {
                list.push({id: `${i}`, label: `${i}`})
            }
            return list;
        },
        /**
         * blur時に月の入力値の有無をチェックする
         */
        onBlur() {
            this.isEmptyMonth = !this.monthValue;
        },
        /**
         * 親にemitする共通メソッド
         */
        emit(monthValue) {
            this.$emit("input", monthValue);
        },
    },
}
</script>
